import apiService from './api-service'

const dashboardService = {}

dashboardService.list = function (params) {
  return apiService.get(`/dashboard`, { params }).then(res => res.data)
}

dashboardService.attachmentList = function (params) {
  return apiService.get(`/dashboard/attachments-expire`, { params }).then(res => res.data)
}

dashboardService.birthdayInvestorsList = function (params) {
  return apiService.get(`/dashboard/birthday-investors`, { params }).then(res => res.data)
}

dashboardService.missingDocumentstList = function (params) {
  return apiService.get(`/dashboard/missing-documents`, { params }).then(res => res.data)
}

dashboardService.pendingTasksList = function (params) {
  return apiService.get(`/dashboard/pending-tasks`, { params }).then(res => res.data)
}

dashboardService.withdrawsDateRetirement = function (params) {
  return apiService.get(`/dashboard/withdraws-retirement`, { params }).then(res => res.data)
}

export default dashboardService



// WEBPACK FOOTER //
// ./src/services/dashboard.js